import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../config";

function SalaryPage() {
  const user = JSON.parse(localStorage.getItem("user"));
  const empId = user?.employeeId || user?._id || null;
  const [salaryHistory, setSalaryHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    if (!empId) {
      setLoading(false);
      setSalaryHistory([]);
      return;
    }
    fetchSalaryHistory();
  }, [empId, selectedYear]);

  const fetchSalaryHistory = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/salaryhistory/${empId}?year=${selectedYear}`);
      const data = Array.isArray(res.data) ? res.data : [];

      const latestSalary = {};
      data.forEach((item) => {
        const key = `${item.month}-${item.year}`;
        if (!latestSalary[key]) latestSalary[key] = item;
        else if (new Date(item.createdAt) > new Date(latestSalary[key].createdAt)) latestSalary[key] = item;
      });

      const uniqueList = Object.values(latestSalary).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setSalaryHistory(uniqueList);
    } catch (err) {
      console.error("Error fetching salary:", err);
      setSalaryHistory([]);
    }
    setLoading(false);
  };

  const currentMonth = new Date().toLocaleString("en-US", { month: "long" }).toLowerCase();

  const requestAccess = (month, year) => {
    alert(`Request sent to admin for ${month} ${year}`);
  };

  return (
    <div>
      <h2 className="emp-page-title">Salary Dashboard</h2>
      <p className="emp-page-subtitle">Review month-wise salary, deductions, and payout status.</p>

      <section className="emp-panel">
        <div className="emp-panel-body">
          <div className="emp-toolbar">
            <select className="form-select w-auto" value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
              <option value={2023}>2023</option>
              <option value={2024}>2024</option>
              <option value={2025}>2025</option>
              <option value={2026}>2026</option>
            </select>
          </div>

          <div className="emp-table-wrap">
            <table className="table table-striped align-middle">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Basic Pay</th>
                  <th>Deductions</th>
                  <th>Net Salary</th>
                  <th>Status</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                {!loading && salaryHistory.length > 0 ? (
                  salaryHistory.map((item, idx) => {
                    const isCurrentMonth = item.month.toLowerCase() === currentMonth;
                    return (
                      <tr key={idx}>
                        <td>{item.month}</td>
                        <td>{item.year}</td>
                        <td className={!isCurrentMonth ? "opacity-50" : ""}>Rs {Number(item.basicPay || 0).toFixed(2)}</td>
                        <td className={!isCurrentMonth ? "opacity-50" : ""}>
                          <div className="small">
                            <div><b>Total:</b> Rs {Number(item.deductions || 0).toFixed(2)}</div>
                            <div>Absent: Rs {Number(item.deductionDetails?.absent || 0).toFixed(2)}</div>
                            <div>Half Day: Rs {Number(item.deductionDetails?.halfDay || 0).toFixed(2)}</div>
                            <div>Late: Rs {Number(item.deductionDetails?.late || 0).toFixed(2)}</div>
                            <div>Unpaid Leave: Rs {Number(item.deductionDetails?.unpaidLeave || 0).toFixed(2)}</div>
                            {item.deductionDetails?.shortLeave > 0 && (
                               <div>Short Leave: Rs {Number(item.deductionDetails.shortLeave || 0).toFixed(2)}</div>
                            )}
                          </div>
                        </td>
                        <td className={!isCurrentMonth ? "opacity-50" : ""}>Rs {Number(item.netPay || 0).toFixed(2)}</td>
                        <td>
                          {item.status === "Paid" ? (
                            <span className="emp-soft-badge success">Paid</span>
                          ) : (
                            <span className="emp-soft-badge warning">Pending</span>
                          )}
                        </td>
                        <td>
                          {!isCurrentMonth ? (
                            <button className="btn btn-outline-warning btn-sm" onClick={() => requestAccess(item.month, item.year)}>
                              Request Access
                            </button>
                          ) : (
                            <span className="text-success fw-semibold">Available</span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      {loading ? "Loading salary records..." : "No salary data found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SalaryPage;
